import Example from './Example';
import Beranda from './Beranda';
import PusatUnduhan from './PusatUnduhan';
import LaporanSaran from './LaporanSaran';

export const ExampleConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/example',
            component: Example
        }
        ,{
            path     : '/beranda',
            component: Beranda
        }
        ,{
            path     : '/PusatUnduhan',
            component: PusatUnduhan
        }
        ,{
            path     : '/LaporanSaran',
            component: LaporanSaran
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/example/ExampleConfig.js